import { IMedicalPrescriptionMappingConfiguration } from "./imedical-prescription-mapping-configuration";

export class MedicalPrescriptionConfiguration {
  private key: string;
  private companyFiscalNumber: string;
  private enabled: boolean;
  private requiredScan: boolean;
  private purchaseRequiredScan: boolean;
  private medicalPrescriptionMappingConfiguration: Array<IMedicalPrescriptionMappingConfiguration>;

  setKey(key: string): void {
    this.key = key;
  }

  getKey(): string {
    return this.key;
  }

  setCompanyFiscalNumber(value: string): void {
    this.companyFiscalNumber = value;
  }

  getCompanyFiscalNumber(): string {
    return this.companyFiscalNumber;
  }

  setEnabled(value: boolean): void {
    this.enabled = value;
  }

  getEnabled(): boolean {
    return this.enabled;
  }

  setRequiredScan(value: boolean): void {
    this.requiredScan = value;
  }

  getRequiredScan(): boolean {
    return this.requiredScan;
  }

  getPurchaseRequiredScan(): boolean {
    return this.purchaseRequiredScan;
  }

  setPurchaseRequiredScan(purchaseRequiredScan: boolean): void {
    this.purchaseRequiredScan = purchaseRequiredScan;
  }

  setMedicalPrescriptionMappingConfiguration(value: Array<IMedicalPrescriptionMappingConfiguration>): void {
    this.medicalPrescriptionMappingConfiguration = value;
  }

  getMedicalPrescriptionMappingConfiguration(): Array<IMedicalPrescriptionMappingConfiguration> {
    return this.medicalPrescriptionMappingConfiguration;
  }

  isNew(): boolean {
    return !this.key;
  }
}
